import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {UrlsResources} from "../urls-resources";
import {HandleError} from '../handle-error';
import * as moment from "moment";
import {Observable} from "rxjs/Observable";
import {SalesDashboardBean} from "./sales-dashboard.model";

@Injectable()
export class SalesService {

  private options = {
    headers: new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8')
  };

  constructor(private http: HttpClient,
              private handleError: HandleError,
              private urlsResources: UrlsResources) {
  }

  getSalesDashboard(rangeDates: Date[]): Observable<any> {

    let methodParams: HttpParams =
      new HttpParams()
        .set('fechaInicial', moment(rangeDates[0]).format("YYYY-MM-DD"))
        .set('fechaFinal', moment(rangeDates[1]).format("YYYY-MM-DD"));

    const httpOptions = {
      params: methodParams,
      withCredentials: true
    };

    return this.http.get<SalesDashboardBean>(this.urlsResources.getSalesDashboard(), httpOptions)
      .map(response => {
        return response;
      }).catch(error => {
        return this.handleError.handleErrorAsObservable(error)
      });

  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/sales/sales.service.ts